import {
  AnalyticsServiceLineEnum,
  analyticsServiceLineLabels,
} from 'utils/enums';

// Sidebar service lines.
//  - `serviceLine` — passed to the analytics API as the {serviceLine} route
//                    param; matches the backend AnalyticsServiceLine enum
//                    (Neuro, TeleNH, Eeg, PedsEeg)
//  - `path`        — URL slug (e.g. /analytics/neuro)
//  - `label`       — sidebar display text
// The sidebar is filtered to the service lines assigned to the current user;
// for the initial release only Neuro is active.
// eslint-disable-next-line import/prefer-default-export
export const analyticsServiceLines = Object.values(AnalyticsServiceLineEnum).map(
  (serviceLine) => ({
    serviceLine,
    path: serviceLine.toLowerCase(),
    label: analyticsServiceLineLabels[serviceLine],
  }),
);
